const DIRECTIONS = [
  [0, 1], [0, -1], [1, 0], [-1, 0],
  [1, 1], [1, -1], [-1, 1], [-1, -1],
];

function randomLetter() {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  return letters[Math.floor(Math.random() * letters.length)];
}

export function generateWordSearchGrid(words, gridsize) {
  const grid = Array.from({ length: gridsize }, () => Array(gridsize).fill(null));
  const sorted = [...words].sort((a, b) => b.length - a.length);

  sorted.forEach((word) => {
    let placed = false;
    let attempts = 0;
    while (!placed && attempts < 200) {
      attempts++;
      const [dr, dc] = DIRECTIONS[Math.floor(Math.random() * DIRECTIONS.length)];
      const row = Math.floor(Math.random() * gridsize);
      const col = Math.floor(Math.random() * gridsize);
      const endRow = row + dr * (word.length - 1);
      const endCol = col + dc * (word.length - 1);
      if (endRow < 0 || endRow >= gridsize || endCol < 0 || endCol >= gridsize) continue;

      let fits = true;
      for (let i = 0; i < word.length; i++) {
        const r = row + dr * i;
        const c = col + dc * i;
        const existing = grid[r][c];
        if (existing !== null && existing !== word[i]) {
          fits = false;
          break;
        }
      }
      if (!fits) continue;

      for (let i = 0; i < word.length; i++) {
        const r = row + dr * i;
        const c = col + dc * i;
        grid[r][c] = word[i];
      }
      placed = true;
    }
  });

  for (let r = 0; r < gridsize; r++) {
    for (let c = 0; c < gridsize; c++) {
      if (grid[r][c] === null) grid[r][c] = randomLetter();
    }
  }

  return grid;
}
